import React from 'react'
import { format } from 'date-fns'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card from '@SonarCX/components/atoms/Card'

import { getCost } from '../InvoiceSettings/helpers'
import { useInvoice } from '@SonarCX/providers/InvoiceProvider'
import useStyles from './styles'

const InvoiceCards: React.FC = () => {
  const { invoices } = useInvoice()

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {invoices.length === 0 && (
        <Card>
          <div className={classes.noData}>No past invoices</div>
        </Card>
      )}

      {invoices.map((invoice, i) => (
        <Card key={`${invoice.total}-${i}`}>
          {invoice.number && (
            <div className={classes.dataRow}>
              <div className={classes.number}>{invoice.number}</div>
            </div>
          )}

          <div className={classes.dataRow}>
            <div>{format(new Date(invoice.created), 'EEE, MMM d yyyy')}</div>
          </div>

          <div className={classes.dataRow}>
            <div className={classes.cost}>{getCost(invoice)}</div>
          </div>

          <div className={classes.dataRow}>
            <div className={classes.pdf}>
              <a href={invoice.link}>
                <img src='/imgs/billing/file_format_pdf.png' alt='' />
              </a>
            </div>
          </div>
        </Card>
      ))}
    </CardColumn>
  )
}

export default InvoiceCards
